export interface FinalizedUpload {
  id: string;
  sha256: string;
  state: 'pending';
  stored: true;
}
export function finalizedUpload(value: unknown): FinalizedUpload {
  if (!value || typeof value !== 'object') throw Error('storage_finalization_required');
  const row = value as Record<string, unknown>;
  if (
    typeof row.id !== 'string' ||
    !/^[a-f0-9-]{36}$/i.test(row.id) ||
    typeof row.sha256 !== 'string' ||
    !/^[a-f0-9]{64}$/.test(row.sha256) ||
    row.stored !== true ||
    row.state !== 'pending'
  )
    throw Error('storage_finalization_required');
  return { id: row.id, sha256: row.sha256, state: 'pending', stored: true };
}
